import * as stylex from '@stylexjs/stylex';
import { MdCake, MdMale, MdFemale, MdPerson, MdFavorite, MdDiamond, MdHelpOutline } from 'react-icons/md';
import type { IconType } from 'react-icons';
import { styles } from './styles';
import type { PublicProfile } from '~pages/Profile/query';
const ICON_SIZE = 16;
export function Facts({
  user
}: {
  user: PublicProfile;
}) {
  const gender = genderFact(user.gender);
  const relationship = relationshipFact(user.relationshipStatus);
  if (user.age == null && !gender && !relationship) return null;
  return <div {...stylex.props(styles.facts)}>
      {user.age != null && <span {...stylex.props(styles.pill, styles.bgAge)}>
          <MdCake size={ICON_SIZE} {...stylex.props(styles.iconAge)} />
          {user.age} years old
        </span>}
      {gender && <span {...stylex.props(styles.pill, styles.bgGender)}>
          <gender.Icon size={ICON_SIZE} {...stylex.props(styles.iconGender)} />
          {gender.label}
        </span>}
      {relationship && <span {...stylex.props(styles.pill, styles.bgRelationship)}>
          <relationship.Icon size={ICON_SIZE} {...stylex.props(styles.iconRelationship)} />
          {relationship.label}
        </span>}
    </div>;
}
function genderFact(value: PublicProfile['gender']) {
  switch (value) {
    case 'MALE':
      return {
        Icon: MdMale as IconType,
        label: 'Male'
      };
    case 'FEMALE':
      return {
        Icon: MdFemale as IconType,
        label: 'Female'
      };
    case 'OTHER':
      return {
        Icon: MdPerson as IconType,
        label: 'Other'
      };
    default:
      return null;
  }
}
function relationshipFact(value: PublicProfile['relationshipStatus']) {
  switch (value) {
    case 'SINGLE':
      return {
        Icon: MdPerson as IconType,
        label: 'Single'
      };
    case 'IN_RELATIONSHIP':
      return {
        Icon: MdFavorite as IconType,
        label: 'In a Relationship'
      };
    case 'MARRIED':
      return {
        Icon: MdDiamond as IconType,
        label: 'Married'
      };
    case 'COMPLICATED':
      return {
        Icon: MdHelpOutline as IconType,
        label: "It's Complicated"
      };
    default:
      return null;
  }
}